export const eventType = {
	OFFER_CONTENT: "select-content-ofertante",
	OFFER_EDIT: "select-content-edit-ofertante",
	OFFER_CONTENT_MOBILE: "select-content-mobile-ofertante",

	ACCOUNT_FAMILY: 'select-content-account-family'
};

export default eventType;